export const DEFAULT_MARGIN = {
  top: 5,
  right: 30,
  left: 20,
  bottom: 30,
};
